import React, { useRef, useState } from 'react'
import { Hidden, Input } from '@material-ui/core'
import SearchIcon from '@material-ui/icons/Search'
import { useStateWithDebounce } from 'hooks/useStateWithDebounce'
import useStyles from './SearchBar.styles'
import ResultadoPesquisa from './components/ResultadoPesquisa'

export const SearchBar = (props) => {
  const classes = useStyles()
  const searchRef = useRef(null)
  const [openSearchPopover, setOpenSearchPopover] = useState(false)
  const [searchValue, setSearchValue, debouncedSearchValue] = useStateWithDebounce('')

  const handleSearchChange = (event) => {
    const typedValue = event.target.value
    setSearchValue(typedValue)

    if (typedValue) {
      if (!openSearchPopover) {
        setOpenSearchPopover(true)
      }
    } else {
      setOpenSearchPopover(false)
    }
  }

  return (
    <Hidden smDown>
      <div className={classes.search} ref={searchRef}>
        <SearchIcon className={classes.searchIcon} />
        <Input 
          className={classes.searchInput} 
          disableUnderline 
          onChange={handleSearchChange} 
          placeholder="Pesquisar..." 
          value={searchValue} 
          onClick={handleSearchChange} 
        />
      </div>
      <ResultadoPesquisa 
        openSearchPopover={openSearchPopover} 
        setOpenSearchPopover={setOpenSearchPopover} 
        searchRef={searchRef} 
        debouncedSearchValue={debouncedSearchValue} 
      />
    </Hidden>
  )
}

export default SearchBar
